import LoaderGlobal from '@/components/LoaderGlobal'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: LoaderGlobal
	}

	let page = vuewidget(dom, options)
	return page
}